import { render, staticRenderFns } from "./SuperAdminLimitationsSettings.vue?vue&type=template&id=0de86a0d&"
import script from "./SuperAdminLimitationsSettings.vue?vue&type=script&lang=js&"
export * from "./SuperAdminLimitationsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports